<template>
  <layout>
    <page-header :header="$t('drivers.create_driver')" />
    <div class="content">
      <b-card>
        <resource-form
          v-if="currentDivision"
          @saved="returnBack"
          @cancelled="returnBack"
        />
      </b-card>
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'drivers'

export default {
  name: 'DriverCreate',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
